export enum AccessPolicyResource {
  MEDICAL_FILE = 'medical-file',
  PATIENT_DELEGATION = 'patient-delegation',
  ORGANIZATION = 'organization',
  ORGANIZATION_EXTERNAL_PRACTITIONERS = 'organization_external_practitioners',
  PRACTITIONER_CONTACTS = 'practitioner_contacts',
  PRACTITIONER_CALENDAR = 'practitioner_calendar',
}
